export enum RecentOrFavorite {
  Recent = 'Recent',
  Favorite = 'Favorite',
}
